import React from 'react';
import Desktop from '../views/desktop/main.c';
import Tablet from '../views/tablet/main.c';
import Mobile from '../views/mobile/main.c';
import '../less';
import { NAV_CONTEXT } from '../constants';

export default function template() {
    const {isHomePage, showDownloadApp} = this.props,
    userTypes = [
      {
        tab: NAV_CONTEXT.INDIVIDUAL,
        name: this.l10n('HOME_NEW_USER_TYPE_INDIVIDUAL')
      },
      {
        tab: NAV_CONTEXT.BUSINESS,
        name: this.l10n('HOME_NEW_USER_TYPE_BUSINESS')
      }
    ],
    props = {
        ...this.props,
        active: this._getActive(),
        activeSub: this._getSubActive(),
        navigate: this.navigate,
        isBusiness: this.isBusiness(),
        homeUrl: this.homeUrl(),
        userTypes
    },
    { isMobile, isTablet, isDesktop } = this.state;
    return (
        <div className={`module-header${isHomePage ? ' home-page' : ''}${showDownloadApp ? ' show-download-app' : ''}`}>
          {isMobile && <Mobile {...props} />}
          {isTablet && <Tablet {...props} isSearchPage={this.state.isSearchPage}/>}
          {isDesktop && <Desktop {...props} isSearchPage={this.state.isSearchPage}/>}
        </div>
    );
}
